
import { IPeerGroupsStore } from 'model/interfaces';
import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

const initialState = {
peerGroups: [],
};

export const usePeerGroupsStore = create<IPeerGroupsStore>()(
  devtools(
    persist(
      (set) => ({
        ...initialState,
        setPeerGroups: (grups: any) => set({ peerGroups: grups }),
       
        resetPeerGroups: () => set({ ...initialState }),
      }),
      {
        name: 'kf1-peer-groups', // Key name in sessionStorage
        storage: createJSONStorage((): Storage => window.sessionStorage), // Persist to sessionStorage
      },
    ),
  ),
);
